import React from "react";
import { usePageTitle } from "@/lib/usePageTitle";

const SECTIONS = [
  ["What we collect", "Your name, contact details, property address and job details you provide, plus basic usage data needed to run the service."],
  ["How we use it", "To match and coordinate your jobs, process payments, send booking and job updates, and improve the service. We never sell your data."],
  ["Sharing with partners", "We share only the details a tradesperson needs to complete your job — your name, address and the job brief. Payment details are never shared."],
  ["Communications", "You control how we contact you (SMS, WhatsApp, email) from your dashboard notification settings, and can opt out of non-essential messages at any time."],
  ["Data retention", "We keep your account and job history while your account is active, and only as long as needed for legal and accounting purposes afterwards."],
  ["Your rights", "You can request a copy of your data, correct it, or ask us to delete your account by emailing hello@oliviadoes.co.uk."],
  ["Cookies", "We use essential cookies to keep you signed in and the service working. We don't use advertising trackers."],
];

export default function Privacy() {
  usePageTitle("Privacy Policy — Olivia Does");
  return (
    <section className="od-section od-wrap" style={{ maxWidth: 760 }} data-testid="privacy-page">
      <div className="od-eyebrow">Legal</div>
      <h1 className="serif" style={{ fontSize: "2.3rem", fontWeight: 500, margin: "0 0 8px" }}>Privacy Policy</h1>
      <p style={{ color: "var(--taupe)", marginBottom: 30 }}>Last updated June 2026.</p>
      {SECTIONS.map(([h, b]) => (
        <div key={h} style={{ marginBottom: 24 }}>
          <h3 className="serif" style={{ fontWeight: 500, marginBottom: 6 }}>{h}</h3>
          <p style={{ color: "var(--taupe)", lineHeight: 1.7 }}>{b}</p>
        </div>
      ))}
    </section>
  );
}
